import type { IconProps } from '../types';

export function FilesIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M216,76H129.65674L101.17187,47.51514A11.92014,11.92014,0,0,0,92.68652,44H40A12.01343,12.01343,0,0,0,28,56V200.61523A11.398,11.398,0,0,0,39.38477,212h177.5039A11.12373,11.12373,0,0,0,228,200.88867V88A12.01343,12.01343,0,0,0,216,76ZM40,52H92.68652a3.97185,3.97185,0,0,1,2.82813,1.17188L118.34326,76H36V56A4.00458,4.00458,0,0,1,40,52ZM220,200.88867A3.11456,3.11456,0,0,1,216.88867,204H39.38477A3.38879,3.38879,0,0,1,36,200.61523V84H216a4.00458,4.00458,0,0,1,4,4Z"
        fill="currentColor"
      />
    </svg>
  );
}
